import { render, staticRenderFns } from "./CreditNoteButton.vue?vue&type=template&id=04b6fe2c&scoped=true&"
import script from "./CreditNoteButton.vue?vue&type=script&lang=ts&"
export * from "./CreditNoteButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreditNoteButton.vue?vue&type=style&index=0&id=04b6fe2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6fe2c",
  null
  
)

export default component.exports